const memberRouter = [
  {
    path: 'home',
    name: 'memberHome',
    component: () => import("@/components/Member/Home"),
    meta: {
      title: '会员中心检测认证 首页',
      navBol: true
    }
  },
  {
    path: 'order',
    name: 'memberOrder',
    component: () => import("@/components/Member/Order"),
    meta: {
      title: '检测认证 订单',
      navBol: true
    }
  },
  {
    path: 'inquirySheet',
    name: 'memberInquirySheet',
    component: () => import("@/components/Member/InquirySheet"),
    meta: {
      title: '检测认证 询价单',
      navBol: true
    }
  },
  

  
  {
    path: 'testingProgramme',
    name: 'MemberTestingProgramme',
    component: () => import("@/components/Member/TestingProgramme"),
    meta: {
      title: '检测认证 检测方案',
      navBol: true
    }
  },
  {
    path: 'orderEvaluation',
    name: 'MemberOrderEvaluation',
    component: () => import("@/components/Member/OrderEvaluation"),
    meta: {
      title: '检测认证 订单评价',
      navBol: true
    }
  },
  {
    path: 'trainCourse',
    name: 'MemberTrainCourse',
    component: () => import("@/components/Member/TrainCourse"),
    meta: {
      title: '培训 已购课程',
      navBol: true
    }
  },
  {
    path: 'trainOrder',
    name: 'MemberTrainOrder',
    component: () => import("@/components/Member/TrainOrder"),
    meta: {
      title: '培训 培训订单',
      navBol: true
    }
  },
  {
    path: 'trainEvaluation',
    name: 'MemberTrainEvaluation',
    component: () => import("@/components/Member/TrainEvaluation"),
    meta: {
      title: '培训 评价',
      navBol: true
    }
  },
  {
    path: 'myConsultation',
    name: 'MyConsultation',
    component: () => import("@/components/Member/MyConsultation"),
    meta: {
      title: '专家咨询 我的咨询',
      navBol: true
    }
  },
  {
    path: 'consultationOrder',
    name: 'ConsultationOrder',
    component: () => import("@/components/Member/ConsultationOrder"),
    meta: {
      title: '专家咨询 订单',
      navBol: true
    }
  },
  {
    path: 'consultationEvaluation',
    name: 'ConsultationEvaluation',
    component: () => import("@/components/Member/ConsultationEvaluation"),
    meta: {
      title: '专家咨询 评价',
      navBol: true
    }
  },
  {
    path: 'memberCollection',
    name: 'memberCollection',
    component: () => import("@/components/Member/memberCollection"),
    meta: {
      
      title: '会员收藏',
      navBol: true
    }
  },
  {
    path: 'certificate',
    name: 'certificate',
    component: () => import("@/components/Member/certificate"),
    meta: {
      title: '证书管理',
      navBol: true
    }
  },
  {
    path: 'specimen',
    name: 'specimen',
    component: () => import("@/components/Member/specimen"),
    meta: {
      title: '样品管理',
      navBol: true
    }
  },
  {
    path: 'specimenDetail',
    name: 'specimenDetail',
    component: () => import("@/components/Member/specimenDetail"),
    meta: {
      title: '样品详情',
      navBol: true
    }
  },
  {
    path: 'vistedRecords',
    name: 'vistedRecords',
    component: () => import("@/components/Member/vistedRecords"),
    meta: {
      title: '历史纪录',
      navBol: true
    }
  },


  {
    path: 'memberInfo',
    name: 'modifyMemberInfo',
    component: () => import("@/components/Member/MemberInfo/modifyMemberInfo.vue"),
    meta: {
      title: '账户服务-会员信息1 版本1',
      navBol: true
    }
  },
  {
    path: 'modifyInfo',
    name: 'modifyInfo',
    component: () => import("@/components/Member/MemberInfo/modifySuccess.vue"),
    meta: {
      title: '账户服务-会员信息2 版本1',
      navBol: true
    }
  },
  {
    path: 'integral',
    name: 'integral',
    component: () => import("@/components/Member/CouponslManage/myIntegral.vue"),
    meta: {
      title: '账户服务 积分管理',
      navBol: true
    }
  },
  {
    path: 'discountCard',
    name: 'discountCard',
    component: () => import("@/components/Member/CouponslManage/getCoupons.vue"),
    meta: {
      title: '账户服务 积分管理 领取优惠券_1',
      navBol: true
    }
  },
  {
    path: 'myCoupons',
    name: 'myCoupons',
    component: () => import("@/components/Member/MyCoupons"),
    meta: {
      title: '账户服务 我的优惠券 版本_1',
      navBol: true
    }
  },
  {
    path: 'afterSaleMannagement',
    name: 'afterSaleMannagement',
    component: () => import("@/components/Member/afterSaleManagement"),
    meta: {
      title: '售后管理',
      navBol: true
    }
  },
  {
    path: 'afterSale',
    name: 'afterSale',
    component: () => import("@/components/Member/afterSale"),
    meta: {
      title: '售后信息列表',
      navBol: true
    }
  },
  {
    path: 'afterApplication',
    name: 'afterApplication',
    component: () => import("@/components/Member/afterSaleManagement/afterApplication"),
    meta: {
      title: '售后申请',
      navBol: true
    }
  },
  {
    path: 'addressBook',
    name: 'addressBook',
    component: () => import("@/components/Member/AddressBook"),
    meta: {
      title: '地址薄',
      navBol: true
    }
  },
  {
    path: 'afterApplicationDetail',
    name: 'afterApplicationDetail',
    component: () => import("@/components/Member/afterSaleManagement/afterApplicationDetail"),
    meta: {
      title: '售后申请详情',
      navBol: true
    }
  },
  {
    path: 'invoice',
    name: 'invoice',
    component: () => import("@/components/Member/Invoice"),
    meta: {
      title: '发票信息',
      navBol: true
    }
  },
  {
    path: 'menberLevel',
    name: 'menberLevel',
    component: () => import("@/components/Member/menberLevel"),
    meta: {
      title: '会员等级',
      navBol: true
    }
  },
  {
    path: 'menberLevel/myIntegral',
    name: 'menberLevel/myIntegral',
    component: () => import("@/components/Member/menberLevel/myIntegral.vue"),
    meta: {
      title: '会员成长值明细',
      navBol: true
    }
  },
  {
    path: '/UserModifyPsw',
    name: 'UserModifyPsw',
    component: () => import('@/components/Member/UserModifyPsw/index.vue'),
    meta: {
      title: '用户密码修改'
    },
    redirect: '/UserModifyPsw/step1',
    children: [
      {
        path: '/UserModifyPsw/step1',
        name: 'emailStep1',
        component: () => import('@/components/Member/UserModifyPsw/Steps/step1.vue'),
        meta: {
          title: '邮箱/手机找回密码步骤1'
        }
      },
      {
        path: '/UserModifyPsw/step2',
        name: 'emailStep2',
        component: () => import('@/components/Member/UserModifyPsw/Steps/step2.vue'),
        meta: {
          title: '邮箱找回密码步骤2'
        }
      },
      {
        path: '/UserModifyPsw/step3',
        name: 'emailStep3',
        component: () => import('@/components/Member/UserModifyPsw/Steps/step3.vue'),
        meta: {
          title: '邮箱/手机找回密码步骤3'
        }
      },
      {
        path: '/UserModifyPsw/step4',
        name: 'emailStep4',
        component: () => import('@/components/Member/UserModifyPsw/Steps/step4.vue'),
        meta: {
          title: '邮箱/手机找回密码步骤4'
        }
      },
      {
        path: '/UserModifyPsw/step5',
        name: 'emailStep5',
        component: () => import('@/components/Member/UserModifyPsw/Steps/step5.vue'),
        meta: {
          title: '邮箱/手机找回密码步骤5'
        }
      }
    ]
  }
];
export default memberRouter;



// WEBPACK FOOTER //
// ./src/router/Member.js